<div id="beyond">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Workshops</h4>
                  <div class="card-body">
                    <p class="inner-lead">At our school, we are committed to providing a comprehensive education that prepares students for success in college and beyond. Our workshop programme is designed to complement our academic curriculum by providing students with hands-on learning experiences and opportunities to develop skills outside the classroom.</p>
                    <p class="inner-lead">We believe that workshops provide students with a unique opportunity to explore their interests and passions and to develop new skills that will benefit them throughout their lives. Students can participate in workshops that align with their interests and talents, providing them with the opportunity to develop new skills and gain confidence in their abilities. Our school is committed to providing our students with the resources and opportunities they need to achieve their full potential, and our workshop programme is just one of the many ways in which we support their growth and development.</p>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>